import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Pagination } from "swiper/modules";
import "@styles/components/slider.css";
import hoverIntent from "@common/hover-intent";
import { gsap } from "gsap";

const mediaItems = document.querySelector(".home-media-items");

if (mediaItems) {
  new Swiper(mediaItems.querySelector(".swiper"), {
    modules: [A11y, Autoplay, EffectFade],
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
  });
}

const canHoverHomeLeadIn = (el) => {
  if (!el.closest("[data-sr-done]")) {
    return false;
  }

  if (window.matchMedia("(max-width: 1023px)").matches) {
    return false;
  }

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    return false;
  }

  return true;
};

document.querySelectorAll(".home-lead-in").forEach((el) => {
  const container = el.querySelector(".swiper");

  new Swiper(container, {
    modules: [A11y, Autoplay, EffectFade, Pagination],
    autoplay: {
      delay: 4000,
      pauseOnMouseEnter: true,
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
    pagination: {
      el: el.querySelector(".slider-pagination"),
    },
  });

  new hoverIntent([el], {
    onEnter: () => {
      if (canHoverHomeLeadIn(el)) {
        const elRect = el.getBoundingClientRect();
        const container = el.closest(".home-lead-in-container");
        const containerRect = container.getBoundingClientRect();
        const parent = el.parentNode;

        parent.style.width = `${elRect.width}px`;
        parent.style.height = `${elRect.height}px`;

        const growAmount = elRect.top - containerRect.top + parseFloat(window.getComputedStyle(container).marginTop);

        el.style.position = "absolute";

        gsap.to(el, {
          height: elRect.height + growAmount * 2,
          top: -growAmount,
          duration: 0.3,
          ease: "expoScale(0.5, 7, none)",
        });
      }
    },
    onExit: async () => {
      if (canHoverHomeLeadIn(el)) {
        const parent = el.parentNode;

        await gsap.to(el, { height: parent.offsetHeight, top: "auto", duration: 0.2, ease: "expoScale(0.5, 7, none)" });

        el.style.position = null;
        parent.style = null;
      }
    },
    exitDelay: 100,
    interval: 50,
    sensitivity: 7,
  });
});
